import React from 'react';
import Home from '../pages/Home/Home';
import RouteConfig from './interface';
import renderRoutes from './utils';
import DefaultLayout from '../Layouts/DefaultLayout';
import EmptyPageLayout from '../Layouts/EmptyPageLayout';
import LoginPage from '../pages/LoginPage/LoginPage';
import LogoutPage from '../pages/LogoutPage/LogoutPage';
import PaymentsPage from '../pages/PaymentsPage/PaymentsPage';
import { PAYMENTS_PATH } from '../features/Payments/constants';
import Profile from '../features/Profile/Profile';
import ProductDetails from '../features/Payments/ProductDetails/ProductDetails';
import ExtensionAuth from '../features/ExtensionAuth/ExtensionAuth';

const routes: RouteConfig[] = [
	{
		title: 'Home',
		path: '/',
		component: <Home />,
		layout: EmptyPageLayout,
		exact: true,
		isPublic: true,
	},
	{
		title: 'Login',
		path: '/login',
		component: <LoginPage />,
		layout: DefaultLayout,
		exact: true,
		isPublic: true,
	},
	{
		title: 'Logout',
		path: '/logout',
		component: <LogoutPage />,
		layout: EmptyPageLayout,
		exact: true,
		isPublic: true,
	},
	{
		title: 'Profile',
		path: '/me',
		component: <Profile />,
		layout: DefaultLayout,
		exact: true,
		isPublic: false,
	},
	{
		title: 'Extension Auth',
		path: '/extension-auth',
		component: <ExtensionAuth />,
		layout: DefaultLayout,
		exact: true,
		isPublic: false,
	},
	{
		title: 'Payments',
		path: PAYMENTS_PATH,
		component: <PaymentsPage />,
		layout: DefaultLayout,
		exact: false,
		isPublic: true,
	},
	{
		title: 'Product',
		path: '/product/',
		component: <ProductDetails />,
		layout: DefaultLayout,
		exact: true,
		isPublic: true,
	},
	{
		title: 'Product',
		path: '/product/:productSlug',
		component: <ProductDetails />,
		layout: DefaultLayout,
		exact: false,
		isPublic: true,
	},
	{
		title: '404',
		path: '/*',
		component: (
			<div>
				<h1>404: page not found from route</h1>
			</div>
		),
		layout: DefaultLayout,
		exact: true,
		isPublic: true,
	},
];

export const Routes = renderRoutes(routes);

export default routes;
